// Export the CLI class for programmatic use
export { TinteCLI } from "./tinte-cli";
export type { EditorInstallOptions, TinteTheme } from "./types";
